<template lang="pug">
  .d-contactUs
    .topImg
      img(src="~assets/contactUs/img1.png")
      .title 联系我们
    .tab
      .cont
        .item(v-for="(item,index) in tabDta", :key="index", :class='{activeClass: item.active}',@click="clickTab(index)") {{item.text}}
    .cooperation(v-if="currentTab == 1")
      .title 合作咨询
      .desc 任何问题，欢迎扫码添加懂窝（dongwo_wx）咨询
      img.qrCode(src="~assets/contactUs/img2.jpg")
    .recruitment(v-else)
      .teite 懂窝广招贤才<br/>简历投递：HR@dwnest.com
      .content(v-for="(item1,index1) in recruitmentData", :key="index1")
        .jobs-title(@click="clickOpen(item1.open,index1)") {{item1.title}}
          span(:class="{'open-class': item1.open}")
        .item(v-for="(item2,index2) in item1.contData", :key="index2", v-show="item1.open")
          .lable(v-for="(item3,index3) in item2", :key="index3") {{item3}}

</template>

<script>
export default {
  data() {
    return {
      tabDta: [
        {
          id: 1,
          text: "合作咨询",
          active: true
        },
        {
          id: 2,
          text: "招聘信息",
          active: false
        }
      ],
      currentTab: 1,
      recruitmentData: [
        {
          title: "采购经理",
          open: true,
          contData: [
            [
              "岗位职责：",
              "1、供应商管理：根据货品需求拓展供应商，并根据供应商准入机制进行验厂，商务谈判和合同签订及订单跟进；",
              "2、供应商运营：统筹供应商的分层运营规划，维护好供应商的合作关系，确保日常运营工作的正常开展。并根据日常运营数据（销量、服务、品质）考核合作供应商，汰换不合格供应商，解决日常售后问题；",
              "3、货品规划：根据行业趋势和用户需求，确认各个梯队的货品矩阵。补充好货，汰换非畅销商品；",
              "4、新品开发：统筹所辖风格的新品选品，打样及量产工作；",
              "5、备货与库存：关注采购备货需求及实时库存情况，避免出现滞销库存。",
            ],
            [
              "任职要求：",
              "1、本科以上学历，3年以上外贸家具零售经验采购经验，优秀者可适当放宽；",
              "2、对行业整体发展有较强的宏观思考及规划能力；",
              "3、有较好的用户视角和审美能力；",
              "4、有较强的商业谈判和解决突然情况的解决问题的能力；",
              "5、对数据敏感，有一定的逻辑及分析判断能力；",
              "6、拥抱变化，有良好的抗压性，对家具行业充满热爱；",
              "7、良好的团队管理能力和沟通技巧，能和不同部门进行沟通及合作。",
            ]
          ]
        },
        {
          title: "门店销售",
          open: false,
          contData: [
            [
              "岗位职责：",
              "1、提高品牌形象，达成个人销售指标；",
              "2、店铺陈列及产品的清洁与维护；",
              "3、负责门店客户的日常接待，产品介绍，维护及跟进；",
              "4、能为客户提供简单的软装建议；",
              "5、底薪+提成（多劳多得，提成丰厚）",
            ],
            [
              "任职要求：",
              "1、年龄：22-35岁，学历：大专/本科优先；",
              "2、有家具家居经验者优先；",
              "3、有室内设计能力及经验者优先。"
            ]
          ]
        }
      ]
    };
  },
  watch: {
    $route() {
      var currentTab = this.$route.query.currentTab;
      if (currentTab) {
        this.currentTab = this.$route.query.currentTab;
        this.tabDta.forEach((val, index) => {
          if (val.id == currentTab) {
            (val.active = true), (this.currentTab = currentTab);
          } else {
            val.active = false;
          }
        });
      }
    }
  },
  created() {
    var currentTab = this.$route.query.currentTab;
    if (currentTab) {
      this.currentTab = this.$route.query.currentTab;
      this.tabDta.forEach((val, index) => {
        if (val.id == currentTab) {
          (val.active = true), (this.currentTab = currentTab);
        } else {
          val.active = false;
        }
      });
    }
  },
  methods: {
    clickTab(i) {
      this.tabDta.forEach((val, index) => {
        if (i == index) {
          (val.active = true), (this.currentTab = val.id);
        } else {
          val.active = false;
        }
      });
    },
    clickOpen(flag, i) {
      this.recruitmentData.forEach((val, index) => {
        val.open = false;
        if (i == index) {
          val.open = !flag;
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-contactUs
  width: 100%
  box-sizing: border-box
  font-family: PingFangSC-Medium
  .topImg
    width: 100%
    position: relative
    img
      width: 100%
    .title
      margin: auto
      position: absolute
      left: 0
      right: 0
      top: 0
      bottom: 0
      z-index: 10
      width: r(252)
      height: r(80)
      font-size: r(62)
      color: #FFFFFF
  .tab
    margin: r(92) auto 0
    width: r(1370)
    height: r(62)
    border-top: 1px solid #CFD0D1
    border-bottom: 1px solid #CFD0D1
    .cont
      margin: 0 auto
      width: r(848)
      height: 100%
      display: flex
      justify-content: space-between
      .item
        width: r(167)
        height: 100%
        font-size: r(36)
        color: #585858
        text-align: center
        line-height: r(62)
      .activeClass
        font-size: r(36)
        color: #070809
        border-bottom: r(3) solid #040506
  .cooperation
    margin: r(92) auto 0
    width: r(1370)
    .title
      margin-top: r(140)
      width: 100%
      font-size: r(30)
      color: #070809
      text-align: center
    .desc
      margin-top: r(69)
      width: 100%
      font-size: r(20)
      color: #585858
      text-align: center
    .qrCode
      margin: r(73) auto r(147)
      display: block
      width: r(180)
  .recruitment
    margin: r(92) auto 0
    width: r(1120)
    padding-bottom: r(310)
    .teite
      margin-top: r(127)
      margin-bottom: r(80)
      width: 100%
      font-size: r(30)
      color: #070809
      text-align: center
      line-height: r(45)
    .content
      width: 100%
      border-bottom: 1px solid #CFD0D1
      .jobs-title
        display: inline-block
        min-width: 100%
        height: r(97)
        font-size: r(32)
        color: #030304
        line-height: r(97)
        span
          margin-left: r(28)
          border-top: 1px solid #030304
          border-right: 1px solid #030304
          content: ""
          display: inline-block
          width: r(20)
          height: r(20)
          transform: rotateZ(135deg)
        .open-class
          transform: rotateZ(-45deg)
      .item
        margin-top: r(44)
        font-family: PingFangSC-Regular
        font-size: r(20)
        color: #373738
        line-height: r(33)
        &:last-child
          margin-bottom: r(80)
</style>



// WEBPACK FOOTER //
// contactUs.vue?2f6c688a